import * as React from 'react';
import { Store } from '../../../../stores';
import { inject, observer } from 'mobx-react';
import { IADropDown } from '../../../../../dropDown/DropDown';
import { LocalizationService } from '../../../../../../services/LocalizationService';
import { IPlayProfile } from '../../../../../../interfaces/IPlay';
import { IATextField } from '../../../../../textField/TextField';
import PlayService from '../../../../../../services/PlayService';
import { IASpinner } from '../../../../../spinner/Spinner';

export interface IProps {
  store?: Store;
  profiles: IPlayProfile[];
  isEditingExistingIntegration: boolean;
  onProfileChange: (profile) => void;
  onChange: (isConnected: boolean) => void;
}

export interface IState {
  isLoadingValidation: boolean;
  showValidationError: boolean;
  hasValidatedSuccessfully: boolean;
}

@inject('store')
@observer
export class TimeEditIntegrationComponent extends React.Component<IProps, IState> {
  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      isLoadingValidation: false,
      showValidationError: false,
      hasValidatedSuccessfully: false
    }
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  private onInputChange(){
    const hasData = !!this.props.store.integrationToEdit.timeEditIntegration?.customerSpecificUrl && !!this.props.store.integrationToEdit.timeEditIntegration.password && !!this.props.store.integrationToEdit.timeEditIntegration.username;
    if (hasData) {
      this.setState({ isLoadingValidation: true, showValidationError: false });
      PlayService.validateTimeEditIntegration(this.props.store.environment, this.props.store.token, this.props.store.tenantId, this.props.store.profile?.id, this.props.store.integrationToEdit.timeEditIntegration).then(value => {
        this.props.onChange(value.validated);
        if (!value.validated) {
          this.setState({ showValidationError: true, hasValidatedSuccessfully: false });
        } else {
          this.setState({ showValidationError: false, hasValidatedSuccessfully: true });
        }
      }).finally(() => {
        this.setState({ isLoadingValidation: false });
      });
    } else {
      this.props.onChange(false);
      this.setState({showValidationError: false});
    }
  }

  public render(): JSX.Element {
    return (
      <>
        <IADropDown
          label={this.localizationService.strings.PlayAdmin_SelectAProfileToAccess?.toUpperCase()}
          selectedOption={this.props.store.integrationToEdit?.profileId}
          options={[{
            key: undefined,
            value: this.localizationService.strings.PlayAdmin_SelectAProfileToAccess,
            disabled: true
          },
          ...this.props.profiles.map(profile => { return { key: profile.id, value: profile.title } })
          ]}
          disabled={this.props.isEditingExistingIntegration}
          darkMode={this.props.store.darkMode}
          highlightColor={this.props.store.highlightColor}
          onChange={(profile) => {
            this.props.onProfileChange(profile)
          }}
          style={{
            float: "left",
            width: 340
          }}
          borderRadius={5}
        />
        <div style={{ clear: "both", float: "left", marginTop: 15, fontStyle: "italic", width: "100%" }}>{this.localizationService.strings.PlayAdmin_PowerBI_Workspases_Message1} <a href="https://docs.intraactive.net/intraactive-replay/integrations/#section-header-two-9i1aa" target='_blank'>{this.localizationService.strings.PlayAdmin_PowerBI_Workspases_Message2}</a> {this.localizationService.strings.PlayAdmin_TimeEditSetupInstructions}</div>
        {this.props.store.integrationToEdit?.profileId &&  
          <>
            <IATextField
              label={this.localizationService.strings.PlayAdmin_TimeEditUsername}
              text={this.props.store.integrationToEdit?.timeEditIntegration?.username}
              onChange={username => {
                this.props.store.integrationToEdit.timeEditIntegration.username = username;
                this.onInputChange();
              }}
              highlightColor={this.props.store.highlightColor}
              darkMode={this.props.store.darkMode}
              borderRadius={5}
            />
            <IATextField
              label={this.localizationService.strings.PlayAdmin_TimeEditPassword}
              secure
              text={this.props.store.integrationToEdit?.timeEditIntegration?.password}
              onChange={password => {
                this.props.store.integrationToEdit.timeEditIntegration.password = password;
                this.onInputChange();
              }}
              highlightColor={this.props.store.highlightColor}
              darkMode={this.props.store.darkMode}
              borderRadius={5}
            />
            <IATextField
              label={this.localizationService.strings.PlayAdmin_TimeEditCustomerSpecificUrl}
              text={this.props.store.integrationToEdit?.timeEditIntegration?.customerSpecificUrl}
              onChange={customerSpecificUrl => {
                this.props.store.integrationToEdit.timeEditIntegration.customerSpecificUrl = customerSpecificUrl;
                this.onInputChange();
              }}
              highlightColor={this.props.store.highlightColor}
              darkMode={this.props.store.darkMode}
              borderRadius={5}
              onlyPaste
            />
            <div style={{ clear: "both", float: "left", marginTop: 15, fontStyle: "italic", width: "100%" }}>
              {this.state.isLoadingValidation && 
                <>
                  <div style={{width: "100%", textAlign: "center"}}>{this.localizationService.strings.PlayAdmin_RelesysValidating}</div>
                  <IASpinner style={{marginTop: 30, marginBottom: 10}} color={this.props.store.highlightColor}/>
                </>
              }
              {this.state.showValidationError && <>{this.localizationService.strings.PlayAdmin_TimeEditValidationError}</>}
              {this.state.hasValidatedSuccessfully && <>{this.localizationService.strings.PlayAdmin_TimeEditValidationSuccess}</>}
            </div>
          </>
        }
      </>
    );
  }
}